module.exports = __webpack_public_path__ + "img/normal_icon_03.d48a30c.png";